export default {
  events: {},
};
